// extracted by mini-css-extract-plugin
export default {"container":"dzMfqbcx990DgFnoF017"};